import styled from 'styled-components';

export const StyledGroupCallControllerContainer = styled.div`
    ${({ mdUp }) => `
        background-color: rgba(32, 35, 50, 0.9);
        width: 335px;
        height: 75px;
        border-radius: 16px;

        display: flex;
        align-items: center;
        justify-content: center;
        column-gap: 30px;

        position: -webkit-sticky;
        position: fixed;
        margin-left: auto;
        margin-right: auto;
        left: 0;
        right: 0;
        bottom: 10px;
        text-align: center;

        // opacity: ${mdUp ? 0 : 1};
        opacity: 0.8;
        transition: opacity .2s ease-out;
    
        // &:hover {
        //     opacity: 1;
        // }
    `}
`;
